var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.56689 14.8519C6.80178 14.2643 7.15343 13.7244 7.60708 13.2678C8.19872 12.6725 8.93145 12.2517 9.72619 12.0386C10.6795 11.8424 11.2002 11.8367 12.155 12.0386C12.9497 12.2517 13.6824 12.6725 14.2741 13.2678C14.9129 13.9107 15.4302 14.8727 15.5425 15.5927C15.6548 16.3127 15.611 16.4514 15.6548 17.0015V17.3809H9.01401",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9734 5.56253C6.93213 7.6229 5.72756 6.68058 5.30296 5.88198C5.10058 5.56652 5.34263 5.03146 6.03311 4.52833C7.26021 3.66146 8.65104 3.0639 10.1153 2.77032C10.7546 2.63928 11.1447 2.61001 11.7736 2.62131C13.1572 2.67171 14.743 3.10515 15.4418 4.23284C16.1879 5.39482 14.5472 7.03777 14.5472 7.03777",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29386 17.3809C4.29386 17.3809 1.65498 14.3541 3.92879 14.0067C6.39307 13.6354 9.08751 17.3809 9.08751 17.3809H4.29386Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22064 6.80848C7.88119 7.32579 7.68359 7.94565 7.68359 8.61195C7.68359 10.422 9.14176 11.8893 10.9405 11.8893C12.7393 11.8893 14.1975 10.422 14.1975 8.61195C14.1975 6.83757 12.7712 5.6132 11.0204 5.56569",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtist);
export default __webpack_public_path__ + "static/media/artist.47e838a0de1a031afaf1c7bb521b415d.svg";
export { ForwardRef as ReactComponent };